import type { IAdvancedPermissionInjectable } from '../../core/interface';

export default class AdvancedPermissionInjectable implements IAdvancedPermissionInjectable {
    public showAdvancedPermissionDialog(container: HTMLElement) {
        return false;
    }
}
